export default "__VITE_ASSET__3Lrf7vA$GngskD3e2_Wsaw__";